import { render } from "./vcoursewarelistadd.vue?vue&type=template&id=1280504f&scoped=true"
import script from "./vcoursewarelistadd.vue?vue&type=script&lang=js"
export * from "./vcoursewarelistadd.vue?vue&type=script&lang=js"

import "./vcoursewarelistadd.vue?vue&type=style&index=0&id=1280504f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1280504f"]])

export default __exports__